<template>
  <v-layout>
    <v-flex xs12 sm11 offset-sm1>
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <form @submit.prevent="onSaveForm">
      <div class="save-but-sticky">
        <v-layout>
          <v-flex grow></v-flex>
          <v-flex shrink><v-btn depressed  color="accent" type="submit" :disabled="loading" :loading="loading">
          Save
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </v-btn></v-flex>
        </v-layout>
      </div>
      <v-layout>
        <v-flex xs12 >
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <v-layout row wrap pb-3>
                <v-flex xs12 >
                  <span class="subheading">Company name</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8 >
                  <v-text-field
                  name="groupTitle"
                  label="Name of company"
                  id="groupTitle"
                  v-model="group.title"
                  type="text"
                  required></v-text-field>
                </v-flex>
                <v-flex xs12 md3 offset-md1 pt-2>
                </v-flex>
              </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <v-layout row wrap :class="{'pb-2' : $vuetify.breakpoint.xsOnly, 'pb-5' : !$vuetify.breakpoint.xsOnly}">
                <v-flex xs12 md6>
                  <span class="subheading">Company logo</span>
                </v-flex>
                <v-flex xs12 md6 pt-2 pb-3 text-xs-left text-md-right>
                  <span class="caption light">A PNG file around 500px by 500px is a good size.</span>
                </v-flex>
              </v-layout>
              <v-layout align-end row fill-height>
                <v-flex xs8 md4 offset-md4 pr-4 text-xs-left >
                  <img :src="imageUrl" alt="logo" class="business-logo" v-if="imageUrl">
                </v-flex>
                <v-flex xs4 md3 offset-xs1 text-xs-left>
                  <v-btn v-if="imageUrl" depressed block color="error" @click="removeLogo">Delete</v-btn>
                  <v-btn class="mt-1" depressed block color="primary" @click="onPickFile">{{uploadLabel}}</v-btn>
                  <input
                  type="file"
                  style="display:none;"
                  ref="fileInput"
                  accept="images/*"
                  @change="onFilePicked">
                </v-flex>
              </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white  py-4"  :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly, 'misty' :!hasProAccess}">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading" v-if="hasProAccess">Quote numbering</span>
                  <span class="subheading" v-else>Quote numbering (Pro only)</span>
                </v-flex>
              </v-layout>
                <v-flex xs12>
                  <p class="caption light">Turn on automatic numbering and we will sequentially increase your quotes from the next number.</p>
                </v-flex>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                    <invoice-number-format
                    v-bind:autoIncrement.sync="group.autoQuoteIncrement"
                    v-bind:nextNumber.sync="group.nextQuoteNumber"
                    v-bind:autoIncrementPrefix.sync="group.autoQuoteIncrementPrefix"
                    v-bind:disableInputs="!hasProAccess"
                    ></invoice-number-format>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                  </v-flex>
                </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4"  :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Invoice numbering</span>
                </v-flex>
              </v-layout>
                <v-flex xs12>
                  <p class="caption light">Turn on automatic numbering and we will sequentially increase your invoices from the next number.</p>
                </v-flex>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                    <invoice-number-format
                    v-bind:autoIncrement.sync="group.autoIncrement"
                    v-bind:nextNumber.sync="group.nextNumber"
                    v-bind:autoIncrementPrefix.sync="group.autoIncrementPrefix"
                    ></invoice-number-format>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                  </v-flex>
                </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Quote &amp; Invoice defaults</span>
                </v-flex>
              </v-layout>
                <v-flex xs12>
      <p class="caption light">Sets the default footer information used on quotes and invoices.</p>
    </v-flex>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                      <address-fields
                        :companyAddress.sync="group.companyAddress"
                        :groupAddress1.sync="group.groupAddress1"
                        :groupAddress2.sync="group.groupAddress2"
                        :groupCityRegion.sync="group.groupCityRegion"
                        :groupCountyState.sync="group.groupCountyState"
                        :groupPostcode.sync="group.groupPostcode"
                        :groupCountry.sync="group.groupCountry"
                      ></address-fields>
                      <v-textarea
                      name="paymentTerms"
                      label="Payment &amp; Terms instructions"
                      id="paymentTerms"
                      v-model="group.paymentTerms"
                      placeholder=" "
                      auto-grow
                      rows="5"
                      ></v-textarea>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                  </v-flex>
                </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Tax</span>
                </v-flex>
              </v-layout>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                      <v-layout row>
                      <v-flex>
                        <tax-choices v-bind:chargeTax.sync='group.chargeTax' v-bind:taxLabel.sync='group.taxLabel' v-bind:taxCalcInclusive.sync='group.taxCalcInclusive' v-bind:displayWithTax.sync='group.displayWithTax' />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md8 v-if="group.chargeTax">
                    <v-radio-group v-model="group.taxRate">
                      <template v-slot:label>
                        <p class="caption light text-xs-left">Manage your {{group.taxLabel || "VAT"}} rates
                          <v-tooltip top color="primary" >
                          <div class="pa-2">
                            <p class="ma-0">Click on a tax rate to set it as the default.</p>
                          </div>
                            <div slot="activator" style="display:inline; cursor:help;">
                              <v-icon small color="primary" style="opacity:.5;">help_outline</v-icon>
                            </div>
                        </v-tooltip></p>
                      </template>
                      <v-radio color="primary" v-for="(item, itemsindex) in group.taxRates"  :key="itemsindex" :value="item.rate">
                        <template v-slot:label>
                          <span style="min-width:150px;">
                            {{item.rate}}&percnt;
                            <span v-if="item.rate === group.taxRate">(Default)</span>
                          </span>
                          <v-icon class="small-icon error--text" @click="deleteTaxRate(itemsindex)" >close</v-icon>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 md8 v-if="group.chargeTax">
                    <v-layout align-center row fill-height>
                      <v-flex xs2>
                        <v-text-field
                        v-model="newTaxRate"
                        placeholder=" "
                          label="Add tax rate"
                          type="text"
                          mask='##'
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-btn depressed small class="ml-4 tinybut faded fadegrey--text text-none" @click="addTaxRate" :disabled="!this.newTaxRate">
                          + add
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                  </v-flex>
                </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <v-layout row wrap pb-3>
              <v-flex xs12>
                <span class="subheading">Business defaults</span>
              </v-flex>
            </v-layout>
              <v-layout align-end row fill-height wrap>
                <v-flex xs12 md8>
                  <v-layout row>
                  <v-flex xs12>
                    <v-select
                      v-bind:items="timescales"
                      v-model="group.chosenAlertTimeScale"
                      label="Alert unpaid invoices after"
                      :menu-props="{ bottom: true }"
                    ></v-select>

                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-select
                      v-bind:items="timescales"
                      v-model="group.archiveJobsAfterDays"
                      label="Auto archive paid jobs after"
                      :menu-props="{ bottom: true }"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-autocomplete
                      v-bind:items="currency"
                      item-value="code"
                      v-model="chosenCurrency"
                      label="Currency"
                      :menu-props="{ bottom: true }"
                      return-object
                    >
                      <template slot="selection" slot-scope="data">
                      {{ data.item.name }} {{ data.item.symbol }}
                      </template>
                      <template slot="item" slot-scope="data">
                      {{ data.item.name }} {{ data.item.symbol }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="timezones"
                      v-model="group.tz"
                      label="Timezone"
                    >
                  </v-autocomplete>
                  </v-flex>
                </v-layout>
                </v-flex>
                <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                </v-flex>
              </v-layout>
          </div>
        </v-flex>
      </v-layout>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import Currencies from '@/data/currencies.js'
import Timezones from '@/data/IANAtimezones.js'
import InvoiceNumberFormat from '@/components/Shared/InvoiceNumberFormat.vue'
import TaxChoices from '@/components/Shared/TaxChoices'
import AddressFields from '@/components/Shared/AddressFields'

export default {
  components: {
    InvoiceNumberFormat,
    TaxChoices,
    AddressFields
  },
  data () {
    return {
      group: this.$store.getters.group,
      imageUrl: this.$store.getters.group.logo,
      timescales: [
        { text: '1 day', value: '1' },
        { text: '7 days', value: '7' },
        { text: '14 days', value: '14' },
        { text: '30 days', value: '30' },
        { text: '60 days', value: '60' },
        { text: '90 days', value: '90' }
      ],
      chosenCurrency: {
        code: this.$store.getters.group.currCode,
        symbol: this.$store.getters.group.currSymbol
      },
      currency: Currencies,
      timezones: Timezones,
      // maybe in future at some point
      // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      // for now use the ipdata
      timezone: null,
      newTaxRate: null
    }
  },
  watch: {
    chosenCurrency: function (val) {
      this.group.currCode = val.code
      this.group.currSymbol = val.symbol
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    uploadLabel () {
      if (this.imageUrl !== null && this.imageUrl !== undefined && this.imageUrl !== '') {
        return 'Change'
      } else {
        return 'Add'
      }
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  },
  methods: {
    onSaveForm () {
      // Vuex
      this.$store.dispatch('updateGroupSettings', this.group)
      this.$store.dispatch('addNotification', { text: 'Business settings saved.', type: 'primary' })
      this.group.newLogo = null
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      // takes the file input's image
      const files = event.target.files
      let filename = files[0].name
      // quick validation
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      // read theimage to base64 only when finished load
      // and add to data imageUrl
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      // also store the image itself
      this.group.newLogo = files[0]
    },
    removeLogo () {
      this.$refs.fileInput.value = null
      this.group.logo = null
      this.imageUrl = null
      // TODO remove the file from firebase storage save money!
    },
    addTaxRate () {
      if (!this.newTaxRate) {
        return false
      }
      const newRate = {
        rate: this.newTaxRate
      }
      if (!this.group.taxRates) {
        this.group.taxRates = []
      }
      this.group.taxRates.push(newRate)
      this.newTaxRate = ''
    },
    deleteTaxRate (taxRate) {
      this.group.taxRates.splice(taxRate, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
img.business-logo{
  max-width:100%;
  border:1px dashed grey;
  padding:20px;
}
.save-but-sticky {
  position:sticky;
  padding-bottom:10px;
  padding-top:10px;
  top:35px;
  z-index:1;
  background:#efefef;
  margin-bottom:40px;
  .mdAndDown &{
      top:50px;
  }
}
.line-delete{
  flex-shrink: 0;
  flex-basis:15px;
  margin-left:5px;
}
.small-icon{
  font-size:15px;
}
</style>
